import { cloneElement, useId, type ReactElement, type ReactNode } from "react";

type ResourcePointFormControlProps = {
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
  "aria-labelledby"?: string;
  "aria-required"?: boolean;
};

type ResourcePointFormRowProps = {
  label: string;
  required?: boolean;
  error?: string;
  /** 紧挨主控件右侧的附属操作，例如图标按钮；无障碍名仍挂在主控件上。 */
  accessory?: ReactNode;
  children: ReactElement<ResourcePointFormControlProps>;
};

/** 渲染考察点抽屉中的左标签、右控件与紧邻错误信息行。 */
export function ResourcePointFormRow({
  label,
  required = false,
  error,
  accessory,
  children,
}: ResourcePointFormRowProps) {
  const id = useId();
  const labelId = `${id}-label`;
  const errorId = `${id}-error`;
  const labelledBy = [labelId, children.props["aria-labelledby"]].filter(Boolean).join(" ");
  const describedBy = [children.props["aria-describedby"], error ? errorId : undefined]
    .filter(Boolean)
    .join(" ") || undefined;
  const control = cloneElement(children, {
    "aria-labelledby": labelledBy,
    "aria-required": required || undefined,
    "aria-invalid": error ? true : undefined,
    "aria-describedby": describedBy,
  });

  return (
    <div className="resource-point-form-row" data-testid={`resource-point-form-row-${label}`}>
      <div id={labelId} className="resource-point-form-row__label">
        {required ? (
          <span className="resource-point-form-row__required" aria-hidden="true">*</span>
        ) : null}
        {label}
      </div>
      <div className="resource-point-form-row__control">
        {accessory ? (
          <div className="resource-point-form-row__control-main">
            {control}
            {accessory}
          </div>
        ) : (
          control
        )}
        {error ? (
          <div id={errorId} className="resource-point-form-error" role="alert">{error}</div>
        ) : null}
      </div>
    </div>
  );
}
